// IMPORTANT: L'intercepteur fetch doit être importé EN PREMIER
// pour intercepter tous les appels fetch() de l'application
import './utils/fetchInterceptor';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css'; // Styles globaux (tailles de police, reset)
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);